import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { DirectInputErrorsView } from '../../components/DirectInputErrorsView/DirectInputErrorsView';
import { ErrorItem, ErrorsPresenter } from '../../components/ErrorsPresenter/ErrorsPresenter';
import { ErrorsView } from '../../components/ErrorsView/ErrorsView';
import { InputFieldType } from '../../components/InputField/InputField';
import { ModalDecorator } from '../../components/ModalDecorator/ModalDecorator';
import { Bem } from '../../service/Bem/Bem';
import { ResourceType } from '../common/typings';

import { URL_FORM_ERRORS_PATH } from './typings';
import './UploadByLinkModal.css';
import * as keyset from './UploadByLinkModal.i18n';

const i18n = i18nFactory(keyset);

export interface UploadByLinkModalProps {
    editorId: string;
    isVisible: boolean;
    isLoading?: boolean;
    value: string;
    errors: ErrorItem[];
    urlType: ResourceType;

    onClose: () => void;
    onSave: (editorId: string, url: string, urlType: ResourceType) => void;
    onChange: (url: string) => void;
}

const BLOCK = 'upload-by-link-modal';

const URL_TYPE_PLACEHOLDERS = {
    [ResourceType.audio]: i18n('audio-url'),
    [ResourceType.video]: i18n('video-url'),
    [ResourceType.image]: i18n('image-url')
};

export class UploadByLinkModal extends React.PureComponent<UploadByLinkModalProps> {
    static BottomControls = React.memo(({ onSave, onClose }: { onClose: () => void; onSave: () => void }) => (
        <>
            <ButtonDecorator
                cls={Bem.cls(BLOCK, 'add-button')}
                size="n"
                text={i18n('upload')}
                theme="action"
                view="classic"
                onClick={onSave}
            />
            <ButtonDecorator
                cls={Bem.cls(BLOCK, 'cancel-button')}
                size="n"
                text={i18n('cancel')}
                theme="normal"
                view="classic"
                onClick={onClose}
            />
        </>
    ));

    render(): React.ReactNode {
        const { isVisible, isLoading, onChange, onClose, errors, value, urlType } = this.props;

        return (
            <ModalDecorator
                cls={BLOCK}
                footer={this.renderFooter()}
                onOutsideClick={onClose}
                progress={isLoading}
                visible={isVisible}
            >
                <ErrorsPresenter errors={errors}>
                    <DirectInputErrorsView
                        inputType={InputFieldType.TEXT}
                        theme={'normal'}
                        size={'s'}
                        hasClear={true}
                        text={value}
                        placeholder={URL_TYPE_PLACEHOLDERS[urlType]}
                        path={URL_FORM_ERRORS_PATH}
                        onChange={onChange}
                    />
                    <div
                        className={Bem.cls(BLOCK, 'error', {
                            visible: Boolean(errors && errors.length && errors.find(el => el.path === ''))
                        })}
                    >
                        <ErrorsView path={''} />
                    </div>
                </ErrorsPresenter>
            </ModalDecorator>
        );
    }

    private renderFooter = (): React.ReactNode => {
        const { onClose } = this.props;

        return <UploadByLinkModal.BottomControls onSave={this.onSave} onClose={onClose} />;
    };

    private onSave = (): void => {
        const { editorId, value, onSave, urlType } = this.props;
        onSave(editorId, value, urlType);
    };
}
